var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"labels-select-dropdown-contents gl-absolute gl-my-2 gl-w-full gl-rounded-base gl-py-3",style:(_vm.directionStyle),attrs:{"data-testid":"labels-select-dropdown-contents"}},[_c(_vm.dropdownContentsView,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }